import { GruposAtributosControllerApi, settings } from '@api/backend'
import { displaySuccessMsg } from '@src/utility/Utils'

const prefix = 'grupoatributos'

export const GET_GRUPOATRIBUTO = `${prefix}/GET_DATA_ATRIBUTO`
export const GET_GRUPOATRIBUTOS = `${prefix}/GET_DATA`
export const GET_GRUPOATRIBUTOS_COUNT = `${prefix}/GET_DATA_COUNT`
export const ADD_GRUPOATRIBUTO = `${prefix}/ADD`
export const DELETE_GRUPOATRIBUTO = `${prefix}/DELETE`
export const UPDATE_GRUPOATRIBUTO = `${prefix}/UPDATE`
export const INIT_DATA_NECESARIA = `${prefix}/INIT_DATA_NECESARIA`

const apiGruposAtributos = new GruposAtributosControllerApi(settings)

// ** Get all Data
export const getGrupoAtributos = params => {
  return async (dispatch, getState) => {
    try {

      const { page = 1, perPage = 10, sortBy = "", filtrosBusqueda } = params
      const { searchNombre, searchCodigo } = filtrosBusqueda || {}
      const empresaId = getState().layout.selectedEmpresaId

      const filter = {
        offset: (page - 1) * perPage,
        limit: perPage,
        skip: ((page - 1) * perPage),
        order: sortBy || "nombre ASC",
        where: {
          and: []
        }
      }

      // Siempre incluimos estos filtros ya que tienen valores por defecto
      filter.where.and.push({ empresaId: { eq: `${empresaId}` } })
      filter.where.and.push({ nombre: { like: searchNombre ? `%${searchNombre}%` : '%%' } })
      filter.where.and.push({ codigo: { like: searchCodigo ? `%${searchCodigo}%` : '%%' } })

      const { data: dataGruposAtributos } = await apiGruposAtributos.gruposAtributosControllerFind(JSON.stringify(filter))
      const { data: dataGruposAtributosCount } = await apiGruposAtributos.gruposAtributosControllerCount(JSON.stringify(filter.where))

      dispatch({
        type: GET_GRUPOATRIBUTOS,
        gruposAtributos: dataGruposAtributos,
        total: dataGruposAtributosCount.count || 0,
        params
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const addGrupoatributo = (grupoatributo, intl) => {
  return async (dispatch) => {
    try {
      const { data } = await apiGruposAtributos.gruposAtributosControllerCreate(grupoatributo)
      displaySuccessMsg(intl.formatMessage({ id: 'Grupo atributo creado' }))
      localStorage.setItem("actualizar_GrupoAtributos", "true")
      dispatch({
        type: ADD_GRUPOATRIBUTO,
        data
      })
      // Limpiamos el GrupoAtributo seleccionado
      dispatch({
        type: GET_GRUPOATRIBUTO,
        selectedCompany: null
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const updateGrupoatributo = (id, grupoatributo, intl) => {
  return async (dispatch) => {
    try {
      const { data } = await apiGruposAtributos.gruposAtributosControllerUpdateById(id, grupoatributo)
      displaySuccessMsg(intl.formatMessage({ id: 'Grupo atributo actualizado' }))
      localStorage.setItem("actualizar_GrupoAtributos", "true")
      dispatch({
        type: UPDATE_GRUPOATRIBUTO,
        data
      })
      // Limpiamos el GrupoAtributo seleccionado
      dispatch({
        type: GET_GRUPOATRIBUTO,
        selectedCompany: null
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const deleteGrupoatributo = (grupoatributoId, intl) => {
  return async (dispatch) => {
    try {
      await apiGruposAtributos.gruposAtributosControllerDeleteById(grupoatributoId)
      displaySuccessMsg(intl.formatMessage({ id: 'Grupo atributo eliminado' }))
      dispatch({
        type: DELETE_GRUPOATRIBUTO,
        data: grupoatributoId
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const getGrupoatributo = (grupoatributo) => {
  return async (dispatch) => {
    try {
      const { data: dataGruposAtributo } = await apiGruposAtributos.gruposAtributosControllerFindById(grupoatributo)
      dispatch({
        type: GET_GRUPOATRIBUTO,
        selectedGrupoatributo: dataGruposAtributo,
        ultimoIdGrupoAtributo: grupoatributo
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const initGrupoatributo = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_GRUPOATRIBUTO,
      selectedCompany: null
    })
  }
}
